import React from 'react'
import './styles.css'

export const Skeleton = ({ width, height, borderRadius, style, className, testId = 'skeleton' }) => {
  return (
    <div
      className={`skeleton-box ${className || ''}`}
      data-testid={testId}
      style={{
        width: width || '100%',
        height: height || '1em',
        borderRadius: borderRadius || '4px',
        ...style,
      }}
    />
  )
}

export const CardSkeleton = () => (
  <div className="skeleton-card">
    <Skeleton width="60%" height="1.2em" style={{ marginBottom: '10px' }} />
    <Skeleton width="40%" height="1em" style={{ marginBottom: '20px' }} />
    <div className="d-flex justify-content-between">
      <Skeleton width="30%" height="2em" borderRadius="20px" />
      <Skeleton width="20%" height="2em" borderRadius="20px" />
    </div>
  </div>
)

export const TableSkeleton = ({ rows = 5 }) => (
  <div className="w-100">
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="d-flex gap-3 mb-3">
        <Skeleton width="20%" height="1.5em" />
        <Skeleton width="30%" height="1.5em" />
        <Skeleton width="15%" height="1.5em" />
        <Skeleton width="15%" height="1.5em" />
        <Skeleton width="20%" height="1.5em" />
      </div>
    ))}
  </div>
)

export default Skeleton
